export const ENTRYPOINT = process.env.VUE_APP_API_URL
